import React, {useState} from 'react';
import {Container} from 'react-bootstrap';
import Cookies from "js-cookie";

const WelcomeBackQuote = ({
                            quoteNum,
                            setQuoteNum,
                            errors,
                            setErrors,
                            setContinueOfflinePopupProspectFailed,
                            handleNewQuoteClick,
                            isAAPath,
                            isVTNZPath,
                            searchParams,
                            setSearchParams,
                            url,
                            props,
                            setReturnUser,
                            setVehicleData,
                            setSource,
                            setQuoteData,
                            setVehicleDataPresent
                          }) => {
  const [additionalBenefit, setAdditionalBenefit] = useState(new Map());
  const [currentRenewalId, setCurrentRenewalId] = useState(null);
  const baseUrl = window.location.origin;

  const updateAB = (k, v) => {
    setAdditionalBenefit(additionalBenefit.set(k, v));
  };

  const processApplicantData = (applicant) => {
    if (!applicant) return;

    const fields = [
      'dateOfBirth', 'firstName', 'applicantType', 'businessName',
      'addressLine1', 'addressLine2', 'suburb', 'city', 'postcode'
    ];

    fields.forEach(field => {
      const value = field === 'firstName' ? applicant.firstName : applicant[field];
      props.handleChangeValue(field, value || '');
    });

    props.handleChangeValue('lastName', applicant.surname || '');

    if (applicant.jointDateOfBirth) {
      props.handleChangeValue("joint", true);
      props.handleChangeValue("jointFirstName", applicant.jointFirstName);
      props.handleChangeValue("jointLastName", applicant.jointSurname);
      props.handleChangeValue("jointDateOfBirth", applicant.jointDateOfBirth);
    }

    if (applicant.addressLine1) {
      let fullAddress = applicant.addressLine1;
      if (applicant.addressLine2) fullAddress += ', ' + applicant.addressLine2;
      fullAddress += ', ' + applicant.suburb + ', ' + applicant.city + ', ' + applicant.postcode;
      props.handleChangeValue('full_address', fullAddress);
    }

    props.handleChangeValue("phone", applicant.phone || '');
    props.handleChangeValue("email", applicant.email || '');
  };

  const processVehicleData = (vehicle) => {
    if (!vehicle) return;

    if (vehicle.vehicleValue !== '3000') {
      props.handleChangeValue("exclusions", "NO");
      props.handleChangeValue("isModified", "NO");
      props.handleChangeValue("existingIssue", "NO");
      props.handleChangeValue("vehicleInputOdometerValue", vehicle.updatedOdometerReading);
      props.handleChangeValue("vehicleInputValue", vehicle.vehicleValue);
    }

    props.handleChangeValue("variant", vehicle.variantSelected);
    props.handleChangeValue("registration", vehicle.registration);

    if (vehicle.propulsion) {
      const propulsionTypes = vehicle.propulsion.split(',');
      props.handleChangeValue("propulsionOptions", [...propulsionTypes]);
    }

    setVehicleData(vehicle);
    props.handleChangeValue("vehicleData", vehicle);
  };

  const processQuoteData = (quote) => {
    if (!quote?.cover) return false;

    props.handleChangeValue("quoteExpiry", quote.expiry);

    const coverMap = {
      "SmartCover": "Smart Cover",
      "ExtremePLUS": "Extreme Plus",
      "T05": "Assist",
      "T10": "Assist Plus",
      "ADVANTAGE": "Advantage",
      "ADVANTAGE_PLUS": "Advantage Plus"
    };

    const coverCode = quote.cover;
    const term = quote.term.replace(' months', '');
    const coverName = coverMap[quote.cover] || '';

    props.inputValues.selectedTermAndCover = {coverName, coverCode, term};
    props.handleChangeValue("selectedTermAndCover", props.inputValues.selectedTermAndCover);

    if (quote.excess) {
      props.handleChangeValue("excess", Number(quote.excess.replace('$', '')));
    }

    props.inputValues.quote = JSON.stringify(quote);
    props.updateQuote(JSON.stringify(quote));

    // Process optional components
    const optionalComponents = quote.optionalComponents ? quote.optionalComponents.split(';') : [];
    props.handleChangeValue('consumables', optionalComponents.includes('ConsumableItems'));
    props.handleChangeValue('aaRoadService', optionalComponents.includes('Roadside'));
    props.handleChangeValue('travelDisruption', optionalComponents.includes('TravelDisruption'));

    setQuoteData(quote);
    return true;
  };

  const processAAMemberData = (aaMemberData, quote) => {
    if (!isAAPath) return;

    if (aaMemberData) {
      props.handleChangeValue("aaMembershipNumber", aaMemberData.aaMemberNumber);
      props.handleChangeValue("aaMemberLastName", aaMemberData.lastName);
      props.handleChangeValue("aaMemberDOB", aaMemberData.dateOfBirth);
      props.handleChangeValue("aaMember", "YES");
    } else if (quote?.cover) {
      props.handleChangeValue("aaMember", "NO");
    }
  };

  const createProspectData = (applicant, vehicle, source, apiAaMemberData = null) => {
    const inputValues = props.inputValues;
    const aaMemberData = apiAaMemberData || {
      aaMemberNumber: inputValues.aaMembershipNumber || "",
      lastName: inputValues.aaMemberLastName || "",
      dateOfBirth: inputValues.aaMemberDOB || ""
    };

    const variantElement = document.querySelector('[name="variantInputValue"]');
    const renewalId = currentRenewalId || inputValues.id || searchParams.get("id");

    return {
      id: renewalId,
      vehicleValue: vehicle?.vehicleValue?.replace(/\$|,/g, '') || inputValues.vehicleInputValue?.replace(/\$|,/g, '') || "",
      inceptionKm: vehicle?.updatedOdometerReading || inputValues.vehicleInputOdometerValue || "",
      propulsion: (inputValues.propulsionOptions?.length > 0) ? inputValues.propulsionOptions.toString() : (vehicle?.propulsion || ""),
      exclusions: "",
      variant: variantElement?.value || vehicle?.variantSelected || null,
      aaMemberData: aaMemberData
    };
  };

  const handleRetrieveQuote = () => {
    if (searchParams.has('utm_source')) {
      searchParams.delete('utm_source');
      setSearchParams(searchParams);
    }
    if (searchParams.has('utm_medium')) {
      searchParams.delete('utm_medium');
      setSearchParams(searchParams);
    }
    const renewalId = searchParams.get("id");
    const jwt = Cookies.get('jwt-token');

    // Store renewalId for use in amendQuote
    setCurrentRenewalId(renewalId);
    setErrors({});

    props.handleChangeValue("id", renewalId);
    const newErrors = {}
    if (!quoteNum) {
      newErrors.quoteNum = "Please enter quote number.";
    }
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      return;
    }
    fetch(url + '/prospect/renewal?renewalId=' + encodeURIComponent(renewalId) + '&quoteNum=' + quoteNum, {

      method: "GET", mode: "cors",
      headers: new Headers({
        Accept: "application/json", "Authorization": `Bearer ${jwt}`
      }),
    }).then((response) => {
      if (!response.ok) {
        const newErrors = {}
        newErrors.quoteNum = "Invalid quote number.";
        setErrors(newErrors);
      } else {
        response.json().then((json) => {
          console.log("json", json);
          if (json.status === 'CONVERTED') {
            window.location.href = '/mbi/converted';
          } else if (json.status === 'EXPIRED') {
            window.location.href = '/mbi/expired';

          } else {
            const {applicant, vehicle, quote, source} = json;

            if (source) props.handleChangeValue("source", source);
            setSource(source);

            processApplicantData(applicant);
            processVehicleData(vehicle);
            console.log("here")
            if (!processQuoteData(quote)) return;

            processAAMemberData(json.aaMemberData, quote);
            props.updateBenefits(JSON.stringify(json.additionalbenefits));

            setVehicleDataPresent(true);
            amendQuote(applicant, vehicle, source, json.aaMemberData);

          }
        });
      }
    })
      .catch((err) => console.error("Caught error: ", err));
  };
  const amendQuote = (applicant, vehicle, source, aaMemberData) => {
    const prospectData = createProspectData(applicant, vehicle, source, aaMemberData);

    fetch(`${url}/campaign/policy-renewal/prospects`, {
      method: 'PUT', mode: "cors", headers: {
        'Content-Type': 'application/json', "Authorization": 'By-Pass-Auth-Create-Prospect'
      }, body: JSON.stringify(prospectData)
    })
      .then((response) => response.json())
      .then((data) => {
        const amendQuoteResponse = data.amendQuoteResponse;
        const covers = amendQuoteResponse.covers;

        const isUnderWritingOrNoCover = covers.every(cover =>
          cover.excesses.every(excess => excess.status === "UNDER_WRITING" || excess.status === "NO_COVER")
        );
        if (isUnderWritingOrNoCover) {
          setContinueOfflinePopupProspectFailed(true);
        } else {
          const coverLength = covers.length;
          props.updateAmendQuoteResponse(JSON.stringify(amendQuoteResponse));
          let i = 0;
          const jwt = Cookies.get('jwt-token');
          // check if the current selection is still valid
          const inputValues = props.inputValues;
          const selectedTermAndCover = inputValues.selectedTermAndCover;
          if (selectedTermAndCover) {
            for (let cover of covers) {
              if (cover.coverCode === selectedTermAndCover.coverCode) {
                for (let ex of cover.excesses) {
                  if (ex.excess === inputValues.excess &&
                    (ex.status === 'ACTIVE' || ex.status === 'CONDITIONALLY_ACTIVE')) {
                    for (let pr of ex.premiums) {
                      if (pr.term === selectedTermAndCover.term) {
                        break;
                      }
                    }
                  }
                }
              }
            }
          }

          for (let cover of covers) {
            fetch(`${url}/prospect/quote/additional-benefits?cover=${cover.coverName}&prospectSource=${source}`, {
              method: "GET",
              mode: "cors",
              headers: new Headers({
                Accept: "application/json",
                "Authorization": `Bearer ${jwt}`
              }),
            })
              .then((response) => response.json())
              .then((data) => {
                i++;
                updateAB(cover.coverName, JSON.stringify(data));

                if (i === coverLength) {
                  props.handleChangeValue("additionalBenefit", new Map(additionalBenefit));

                  if (!window.location.hostname.includes('aa')) {
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                      event: 'mbiAutosureEvent',
                      category: 'Submit',
                      status: 'Success',
                      virtualUrl: `${baseUrl}/mbi/step1`,
                      pageTitle: 'Car Details',
                    });
                  }

                  // Complete the retrieve quote flow
                  props.handleChangeValue("retrieveQuote", true);
                  setReturnUser(false);
                  props.nextStep();
                }
              })
              .catch((error) => {
                console.log('Error', error);
              });
          }
        }
      })
      .catch((error) => {
        console.error('API call error:', error);
        setContinueOfflinePopupProspectFailed(true);
      });
  };

  return (
    <>
      <br/> <br/><br/> <br/>
      <div style={{
        width: '100%',
        height: '100%',
        paddingTop: 20,
        justifyContent: 'space-between',
        display: 'flex',
      }}>
        <Container>
          <div style={{flexDirection: 'column'}}>
            <h2>Welcome Back</h2><br/><br/>
            <div className="mediumTextStyles">Enter the quote number from the email we sent you to
              retrieve your
              quote
              <br/>
              <br/>
            </div>
            <div>
              <div className="regularTextStyles">
                Quote Number
              </div>
              <div style={{display: "flex", gap: "10px"}}>
                <input type="text" name="quoteNum" id="quoteNum" value={quoteNum}
                       onChange={e => setQuoteNum(e.target.value)}/>
                <br/>
              </div>
              {errors.quoteNum && (
                <div className="regularErrorStyle">{errors.quoteNum}</div>
              )}
              <div style={{paddingBottom: "1rem"}}></div>
              <button
                style={{
                  color: "white",
                  paddingLeft: 25,
                  paddingRight: 25,
                  paddingTop: 13,
                  paddingBottom: 13,
                  width: "100%",
                  maxWidth: "200px",
                  background: isVTNZPath ? '#E87722' : isAAPath ? '#0d59bf' : '#1851a3',
                  boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.05)',
                  borderRadius: 6,
                  overflow: 'hidden',
                  border: '1px white solid',
                  justifyContent: 'center',
                  alignItems: 'center',
                  display: 'inline-flex',
                  cursor: 'pointer',
                }}
                onClick={handleRetrieveQuote}
              >
                Retrieve my quote
              </button>
            </div>

            <div style={{paddingTop: '2rem'}}>Can't find your details? <span style={{
              color: '#0073CF', textDecoration: "underline",
              cursor: "pointer",
            }}
                                                                             onClick={handleNewQuoteClick}>Start a new quote</span>
            </div>
          </div>
        </Container>
      </div>
    </>
  );
};

export default WelcomeBackQuote;
